// extracted by mini-css-extract-plugin
export default {"content":"src-Read-ResourceAccountRead-ResourceAccountRead-module__content--xWZ9b"};